module.exports = __webpack_public_path__ + "static/img/3.c5bbe60.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/zh/3.png
// module id = OGv1
// module chunks = 0